import { POINTS } from './levelCalculation';

/**
 * Grooming tracker — pure helpers. A curated care checklist (teeth, shower,
 * sunscreen, …) checked off daily; XP is daily-capped adherence (done /
 * scheduled), farm-proof. `sumGroomingXP` is the single definition, crediting the
 * Personal domain once + the Grooming area rank. Modelled on `utils/recovery.ts`.
 *
 * The sub-areas only GROUP the checklist — there is no per-sub-area scoring (no
 * levels, tiers, radar or status window) and no streak. Grooming's standing is
 * its XP, full stop.
 */

export interface GroomingDay {
  date: string; // local YYYY-MM-DD
  doneIds: string[];
  scheduled: number;
}

/** Economy XP for a fully-groomed day (matches the other trackers). */
export const DAILY_GROOMING_XP = 50;

/** 0..100 adherence for a (done, scheduled) pair. */
export function groomingAdherence(done: number, scheduled: number): number {
  if (scheduled <= 0) return 0;
  return Math.min(100, Math.max(0, (done / scheduled) * 100));
}

/** Economy XP for ONE day — proportional to adherence, capped at 100%. */
export function dayGroomingXP(doneCount: number, scheduled: number): number {
  if (scheduled <= 0) return 0;
  // Config-backed cap (console → XP economy); the const above is the default.
  return Math.round(Math.min(1, Math.max(0, doneCount) / scheduled) * (POINTS.TRACKER_GROOMING_DAILY ?? DAILY_GROOMING_XP));
}

/** Total Grooming economy XP across days (single source of truth). */
export function sumGroomingXP(days: ReadonlyArray<GroomingDay>): number {
  return days.reduce((sum, d) => sum + dayGroomingXP(d.doneIds?.length ?? 0, d.scheduled), 0);
}
